import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../../blocks/heigh-educate-banner";
import { HeighEducateChallenge } from "../../../blocks/customer-heigh-educate-challenge";
import { HeighEducateIdea } from "../../../blocks/customer-heigh-educate-idea";
import { CustomerConsult } from "../../../blocks/common-customer-consult";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../../blocks/customer-detail-intro";
import { Footer } from "../../../components/FooterV2";
import { CustomerDetailChallenge } from "../../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const BentleyMotorsPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.bentley-motors.challenge.item1.title"),
      description: t("customer.bentley-motors.challenge.item1.description"),
    },
    {
      title: t("customer.bentley-motors.challenge.item2.title"),
      description: t("customer.bentley-motors.challenge.item2.description"),
    },
    {
      title: t("customer.bentley-motors.challenge.item3.title"),
      description: t("customer.bentley-motors.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.bentley-motors.ideas.item1.title"),
      descript: t("customer.bentley-motors.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.bentley-motors.ideas.item2.title"),
      descript: t("customer.bentley-motors.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.bentley-motors.ideas.item3.title"),
      descript: t("customer.bentley-motors.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="bentley-motors-page">
      <Helmet>
        <title>
          宾利汽车SSO单点登录案例_宾利汽车统一身份认证客户案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.bentley-motors.banner.title")}
        addtionTitle={t("customer.bentley-motors.banner.addtionTitle")}
        subtitle={t("customer.bentley-motors.banner.subtitle")}
        theme="#282D3C"
        imgUrl={
          "//files.authing.co/authing-website/customer-detail-banner-bentley-motors-origin.png"
        }
        alt="汽车行业SSO"
      />
      <CustomerDetailIntro
        imgUrl={t("customer.bentley-motors.intro.imgUrl")}
        alt="汽车行业身份管理方案"
        content={
          <>
            <p>{t("customer.bentley-motors.intro.descript1")}</p>
            <p>{t("customer.bentley-motors.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#282D3C"} />
      <CustomerDetailIdea ideas={ideas} theme={"#282D3C"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#282D3C"} />
      {/* <CustomerConsult /> */}
      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
